export class DefaultDecoder {
  name: string;
  type: string;
  source: string;
  routingKey: string;
  creationDate: number;
  updatedDate: number;

  constructor(name?: string, type?: string, source?: string, routingKey?: string, creationDate?: number, updatedDate?: number) {
    this.name = name;
    this.type = type;
    this.source = source;
    this.routingKey = routingKey;
    this.creationDate = creationDate;
    this.updatedDate = updatedDate;
  }
}
